<mat-card *ngIf="xhrInProgress && !hasError">
  <mat-card-header>
    <mat-card-title>
      <h1>{{'account.title_plural' | translate}}</h1>
    </mat-card-title>
  </mat-card-header>
  <mat-card-content>
    <div class="spinner">
      <mat-progress-spinner color="primary" mode="indeterminate"></mat-progress-spinner>
    </div>
  </mat-card-content>
</mat-card>
<pp-account *ngFor="let account of accounts" [account]="account"></pp-account>
<div class="no-details" *ngIf="hasError">
  <mat-card>
    <mat-card-content>
      <h3>{{'no_details' | translate}}</h3>
    </mat-card-content>
  </mat-card>
</div>
